import * as Actions from './type';
import {
  createPaymentApi,
  getPaymentsByRoApi,
  getApprovedJobsApi,
  getPaymentsApi,
  addEditNotes,
} from '../../api/payment/payment-api';
import { Toast } from '../../components/Toast/Toast';

export const createPayment = (payment) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.MAKE_PAYMENT_REQUEST,
    });
    const { data } = await createPaymentApi(payment);
    dispatch({
      type: Actions.MAKE_PAYMENT_SUCCESS,
      payload: { data, actionType: payment?.actionType || '' },
    });

    if (payment?.roId) {
      dispatch({
        type: 'UPDATE_RO_STAGE_FROM_PAYMENT',
        payload: 'Ready',
      });
    }
  } catch (error) {
    dispatch({
      type: Actions.MAKE_PAYMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getPaymentsByRo = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_PAYMENTS_BY_RO_REQUEST,
    });
    const { data } = await getPaymentsByRoApi(roId);
    dispatch({
      type: Actions.GET_PAYMENTS_BY_RO_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_PAYMENTS_BY_RO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getApprovedJobs = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_APPROVED_JOBS_REQUEST,
    });
    const { data } = await getApprovedJobsApi(roId);
    dispatch({
      type: Actions.GET_APPROVED_JOBS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_APPROVED_JOBS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getPayments = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_PAYMENTS_REQUEST,
    });
    const { data } = await getPaymentsApi();
    dispatch({
      type: Actions.GET_PAYMENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_PAYMENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const addEditPaymentNotes = (notesObj) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.ADD_EDIT_PAYMENT_NOTES_REQUEST,
    });
    await addEditNotes(notesObj);
    Toast('success', 'Notes updated successfully');
    dispatch({
      type: Actions.ADD_EDIT_PAYMENT_NOTES_SUCCESS,
      payload: notesObj,
    });
  } catch (error) {
    Toast('error', error);

    dispatch({
      type: Actions.ADD_EDIT_PAYMENT_NOTES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
